import React, { useState, useEffect } from "react";

function OrderBook() {
  return (
    <div className="flex flex-col w-full p-5 border border-b-400 min-w-min"></div>
  );
}

export default OrderBook;
